import { IWidget } from '../Widget';
import { IMetadata } from 'common/schema/metadata/Metadata';
import { ContextualValueType } from 'common/schema/contextual-value/ContextualValue';

/**
 * Widget Dinamici (Campo Dinamico)
 */
export interface IWidgetDynamic {
  id: number;
  widgetId: number;
  widget: IWidget;

  type: WidgetDynamicType;
  view: WidgetDynamicViewType;

  name: string;
  label: string;

  formula?: DynamicFormula;

  metadata: IMetadata;
}

export enum WidgetDynamicType {
  /** Campo Dinamico */
  Dynamic = 'DynamicField',
  /** Campo Calcolato (matematico) */
  Computed = 'DynamicComputedField'
}

export enum WidgetDynamicViewType {
  None = 'None',
  Text = 'Text',
  TextField = 'TextField'
}

// TODO/LOW Spostare in `editor`?
/** Formula */
export type DynamicFormulaNodeText = {
  // Nodo semplice esclusivamente testuale
  text: string;
};
export type DynamicFormulaNodeMetadata = {
  type: 'metadata';
  children: any;
  label: string;
  metadataId: string;
};
export type DynamicFormulaNodeContextualValue = {
  type: 'contextual';
  children: any;
  label: string;
  contextualValue: ContextualValueType;
};

export type DynamicFormulaNode =
  | DynamicFormulaNodeText
  | DynamicFormulaNodeMetadata
  | DynamicFormulaNodeContextualValue;

export type DynamicFormula = Array<{
  children: DynamicFormulaNode[];
}>;

export const DynamicFormulaNode = {
  isText(node: DynamicFormulaNode): node is DynamicFormulaNodeText {
    return 'text' in node;
  },
  isMetadata(node: DynamicFormulaNode): node is DynamicFormulaNodeMetadata {
    return 'type' in node && node.type === 'metadata';
  },
  isContextual(
    node: DynamicFormulaNode
  ): node is DynamicFormulaNodeContextualValue {
    return 'type' in node && node.type === 'contextual';
  }
};
